import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import classnames from 'classnames';
import Button from 'components/actions/Button';
import type React from 'react';

import './_styles.scss';

interface Props {
    id?: string;
    className?: string;
    type?: 'button' | 'submit';
    label: string | React.JSX.Element;
    tooltip: string;
    isTooltipEnabled?: boolean;
    onClick?(): any;
    isDisabled?: boolean;
    isLoading?: boolean;
}

const ButtonWithTooltip = ({
    id,
    label,
    className,
    tooltip,
    isTooltipEnabled,
    type,
    onClick,
    isDisabled,
    isLoading,
}: Props) => (
    <OverlayTrigger
        placement='top'
        overlay={
            <Tooltip
                className={classnames('ButtonWithTooltip__tooltip', {
                    'ButtonWithTooltip__tooltip--hidden': !isDisabled || isLoading || !isTooltipEnabled,
                })}
            >
                <p>{tooltip}</p>
            </Tooltip>
        }
    >
        <div>
            <Button
                data-testid={`${id}`}
                type={type}
                className={className ?? 'btn btn-primary'}
                onClick={onClick}
                disabled={isDisabled || isLoading}
                isLoading={isLoading}
            >
                {label}
            </Button>
        </div>
    </OverlayTrigger>
);

export default ButtonWithTooltip;
